import React from "react";
import { useTranslation } from "react-i18next";

import { useHistory } from "react-router-dom";
import axios from "axios";
import { displayDateByLanguage } from "../../Utils/utils";

function SheetsPagePreviewCard({ sheet, userData }) {
  let history = useHistory();
  const userLang = userData?.language || 'de';
  const { t } = useTranslation();

  return (
    <li
      key={sheet.sheetName}
      onClick={() =>
        history.push(`/sheet/${sheet.pdfUrl.split("pdf/").pop()}`)
      }
      className="li-height"
    >
      <div className="box-container remove_shadow">
        <img
          className="thumbnail-image"
          src={`${axios.defaults.baseURL}/sheet/thumbnail/${sheet.safeSheetName}`}
		  alt={`${t("common.sheet")} ${t("files.thumbnail")}`}
        />
        <div className="sheet-name-container">
          <span className="sheet-name">{sheet.sheetName}</span>
        </div>
        <div className="sheet-composer-container">
          <span className="sheet-composer"><br/><span className="text-highlight">{sheet.composer}<br/></span>
          {t("sheet.releaseDate")}: <br/><span className="text-highlight">{displayDateByLanguage(sheet.releaseDate, userLang)} <br/></span>
          </span>
        </div>
      </div>
    </li>
  );
}

export default SheetsPagePreviewCard;
